module.exports = __webpack_public_path__ + "static/media/biocertica-logo-with-text-black-horizontal.1f540313.svg";